export default "__VITE_ASSET__BuQH1FZ___"